import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="site-header">
        <div className="container header-inner">
          <div className="brand">
            <img src={logo} className="brand-logo" alt="ecotrack logo" />
            <span className="brand-name">ECOTRACK</span>
          </div>
        </div>
      </header>

      <main className="hero">
        <div className="container hero-inner">
          <div className="hero-copy">
            <h1 className="hero-title">Explora la naturaleza. Protege lo que importa.</h1>
            <p className="hero-sub">Mapas, recursos y herramientas para encontrar lugares, preparar exámenes y participar en la comunidad ecotrack.</p>
            <div className="hero-actions">
              <a className="btn primary" href="https://ecotrack.es/find">Entrar</a>
              <a className="btn primary" href="https://ecotrack.es/exam">Preparar examen</a>
            </div>
          </div>
        </div>
      </main>

      <section className="features container">
        <h2 className="section-title">Qué puedes hacer</h2>
        <div className="features-grid">
          <article className="feature">
            <h3>Buscar lugares</h3>
            <p>Encuentra puntos de interés natural y rutas recomendadas con filtros inteligentes.</p>
          </article>
          <article className="feature">
            <h3>Preparar examen</h3>
            <p>Accede a cuestionarios y materiales para practicar donde quieras.</p>
          </article>
          <article className="feature">
            <h3>Comunidad</h3>
            <p>Comparte hallazgos, participa en eventos y contribuye a mapas colaborativos.</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default App;
